import { useState } from "react";
import { CONTENT } from "@/content";
import { Counter, FormPage, Honeypot, SuccessState, useFormSubmit } from "@/components/forms/FormKit";

const P = CONTENT.prayerRequest;

export default function PrayerRequest() {
  const { ready, status, send, reset } = useFormSubmit("prayer");
  const [request, setRequest] = useState("");
  const [name, setName] = useState("");
  const [hp, setHp] = useState("");
  const [invalid, setInvalid] = useState(false);
  const [sentName, setSentName] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (request.trim().length < 5) { setInvalid(true); return; }
    setInvalid(false);
    setSentName(!!name.trim());
    send({ request: request.trim(), name: name.trim() }, hp);
  };
  const again = () => { setRequest(""); setName(""); reset(); };

  let body;
  if (!ready) body = <p className="panel-line" data-testid="prayer-not-ready">{P.notReady}</p>;
  else if (status === "success") body = <SuccessState heading={P.successHeading} message={sentName ? P.successNamed : P.successAnon} again={P.again} library={P.library} onAgain={again} />;
  else body = (
    <form onSubmit={submit} noValidate className="form-stack" data-testid="prayer-form">
      <div className="anon-notice" data-testid="prayer-anon-notice">
        <span className="pill small-pill">{P.anonPill}</span>
        <p>{P.anonNotice}</p>
      </div>
      <label className="field">
        <span className="field-label">{P.requestLabel}<span className="req-dot" aria-hidden="true" /></span>
        <div className="counter-wrap">
          <textarea className={`nb-input form-input ${invalid ? "is-invalid" : ""}`} rows={7} maxLength={1500} value={request} onChange={(e) => { setRequest(e.target.value); if (invalid && e.target.value.trim().length >= 5) setInvalid(false); }} placeholder={P.requestPlaceholder} aria-invalid={invalid} data-testid="prayer-request-input" />
          <Counter value={request} />
        </div>
        {invalid && <span className="form-error-text" data-testid="prayer-validation-error">{P.validation}</span>}
      </label>
      <label className="field">
        <span className="field-label">{P.nameLabel}</span>
        <input className="nb-input form-input" maxLength={60} value={name} onChange={(e) => setName(e.target.value)} placeholder={P.namePlaceholder} data-testid="prayer-name-input" />
        <span className="field-helper">{P.nameHelper}</span>
      </label>
      <Honeypot value={hp} onChange={setHp} />
      {status === "error" && <p className="form-error-box" data-testid="prayer-error">{P.error}</p>}
      <button type="submit" className="nb-btn form-submit" disabled={status === "sending"} data-testid="prayer-submit-button">{status === "sending" ? P.sending : P.submit}</button>
    </form>
  );

  return (
    <FormPage t={P} testId="prayer-request-page">
      <section className="nb-card form-card">{body}</section>
      <p className="form-note" data-testid="prayer-note">{P.note}</p>
    </FormPage>
  );
}
